(function($){
  'use strict';

  if(!$.tangible){
    $.tangible = new Object();
  };

  $.tangible.timeSwitcher = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.init = function(){
      
      base.$btnPax = $('.js-toggleFlightsPax');

      // Get viewport width
      base.$windowW = $( window ).width();

      // Get x coordinate of active element
      base.$xPos = $( ".c-time-switcher li.is-active" ).offset().left;

      // Get width of active element
      base.$activeLi = $( ".c-time-switcher li.is-active" ).width();

      // Set scroll position to the center of active element
      $( ".c-time-switcher ul" ).scrollLeft( base.$xPos - (base.$windowW/2) + (base.$activeLi/2) );

    };

    base.init();

  };

  $.fn.tangible_timeSwitcher = function(options){
    return this.each(function(){
      (new $.tangible.timeSwitcher(this, options));
    });
  };

})(jQuery);